import { render, staticRenderFns } from "./PrintStep.vue?vue&type=template&id=20a22110&scoped=true&"
import script from "./PrintStep.vue?vue&type=script&lang=js&"
export * from "./PrintStep.vue?vue&type=script&lang=js&"
import style0 from "./PrintStep.vue?vue&type=style&index=0&id=20a22110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a22110",
  null
  
)

export default component.exports